import { ServiceBase } from "@app/shared";
import { UserSession } from "./apiModels";

class UserSessionService extends ServiceBase {
  private authenticationApiEndpoint = `${this.authenticationEndpoint}/api`;

  public async get(): Promise<UserSession[]> {
    return await this.makeGet<UserSession[]>("/account/user-sessions", null, this.authenticationApiEndpoint);
  }
  public async patch(sessions: UserSession[]): Promise<void> {
    return await this.makePatch("/account/user-sessions", sessions, false, this.authenticationApiEndpoint);
  }
}

export {
  UserSessionService,
};
